<script lang="ts">
    import { replace } from 'svelte-spa-router'
    import Summary from '../components/Summary.svelte'
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    if (null === dataProvider.activityId) {
        void replace("/")
    }
</script>

<div class="bno-container bno-container--spread-min bno-container--centered">
    <div class="bno-container__content">
        <h2>Hotovo!</h2>
        <p>
            Gratulujeme, vaše objednávka je úspěšně dokončená. Na váš e-mail
            jsme vám poslali potvrzení objednávky spolu s&nbsp;pokyny, jak
            se k&nbsp;nám dostat a&nbsp;jak se na schůzku připravit.
        </p>
        <p>
            <strong>
                Budeme se na vás těšit! <br/>
                Mějte se krásně!
            </strong>
        </p>
        <Summary {dataProvider} {serviceProvider} update={false}/>
    </div>
</div>
